import React from "react";
import { _goToAttribute } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes } from "assets/constants";

export default function AttributeBox(props: { attr: AttributeT }) {
  const { id, title, items } = props.attr;

  const _goToEdit = () => id && _goToAttribute({ id });

  return (
    <TouchableOpacity
      onPress={_goToEdit}
      style={styles.container}
      activeOpacity={sizes.tapOpacity}
    >
      <View style={styles.titleContainer}>
        <Text weight="bold" size={"lg"}>
          {title}
        </Text>
        <Icon name="chevron-left" />
      </View>
      {items && items?.length > 0 ? (
        <View style={styles.tagsContainer}>
          {[...items.slice(0, 4)].map((item, key) => (
            <View style={styles.tag} key={String(key)}>
              {item && key > 2 ? (
                <Text weight="bold" size={"xxl"} style={{ bottom: 7 }}>
                  ...
                </Text>
              ) : (
                <Text style={{ bottom: 2 }}>{item?.value}</Text>
              )}
            </View>
          ))}
        </View>
      ) : (
        <View style={{ marginTop: 12 }}>
          <Text size={"sm"} color={colors.textColorGray}>
            مقداری برای این ویژگی تعریف نشده است
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    minHeight: 80,
    overflow: "hidden",
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
    paddingHorizontal: 10,
    paddingVertical: 12,
  },

  titleContainer: {
    alignItems: "center",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },

  tagsContainer: { flexDirection: "row-reverse", marginTop: 12 },

  tag: {
    height: 22,
    borderWidth: 1,
    borderColor: colors.border,
    paddingHorizontal: 12,
    marginLeft: 7,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.lightButtons,
  },
});
